import { EditTwoTone, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Col, Row, Spin, Table, Input, Button, Checkbox, Select, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { adminContext } from "../../Common/PageRoute";
import HolidaysDetails from "./HolidaysDetails";
import Link from "antd/es/typography/Link";
import { Utils } from "../../Utilities/Utils";
import HolidaysService from "../../Services/HolidaysService";
import { useUser } from "../../Context/UserContext";
import { PageLayout, PageHeader, SectionCard, TableToolbar } from "../../Common/Layout";
import dayjs, { Dayjs } from "dayjs";
import CustomRangePicker from "../../Common/Custom Components/Ant design/RangePicker";
import { DBRecordStatus } from "../../Common/CommonComponent";
import { ConfirmationModal } from "../../Common/ConfirmationModal";

interface ListDataType {
  id: number;
  name: string;
  date: Dayjs;
  createdBy: any;
  updatedBy: any;
  recordStatus: DBRecordStatus;
}
interface ListData {
  items: ListDataType[];
  totalItems: number;
}

const Holidays = () => {
  const { isSubAdmin } = useUser();
  const { openNotification } = React.useContext(adminContext);
  const [updatesList, setUpdatesList] = React.useState<ListData>({
    items: [],
    totalItems: 0,
  });
  const [loading, setLoading] = React.useState(false);
  // const [selectedDate, setSelectedDate] = React.useState<Dayjs[] | null>([]);
  const [selectedDate, setSelectedDate] = React.useState<{
    fromDate: Dayjs | null,
    toDate: Dayjs | null
  }
  >({
    fromDate: null,
    toDate: null,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [refresh, setRefresh] = React.useState(false);
  const [dialog, setDialog] = React.useState<{ type: string; params: any }>({
    type: "",
    params: {},
  });
  const [listParams, setListParams] = React.useState({
    search: "",
    status: DBRecordStatus.Active,
    sortDir: "descend",
    sortCol: "CreatedBy.Date",
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
  });

  const getItems = async (start: any, length: any) => {
    let res = await HolidaysService.getUpdatesList(
      start,
      length,
      listParams.search,
      listParams.status,
      selectedDate.fromDate ? selectedDate.fromDate?.format("DD-MM-YYYY") : "",
      selectedDate.toDate ? selectedDate.toDate?.format("DD-MM-YYYY") : "",
      listParams.sortCol,
      listParams.sortDir
    );
    if (res?.status) {
      setLoading(false);

      setUpdatesList({
        totalItems: res?.result?.totalRecords,
        items: res?.result?.items,
      });
    } else {
      openNotification("error", res.message);
      setLoading(false);
    }
  };
  React.useEffect(() => {
    setLoading(true);
    getItems(
      (listParams.currentPage - 1) * listParams.pageSize,
      listParams.pageSize
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listParams, refresh, selectedDate]);

  const columns: ColumnsType<ListDataType> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "10%",
      render: (_: any, record: any, index: any) => (
        <p>
          {listParams.currentPage > 1
            ? listParams.pageSize * (listParams.currentPage - 1) + index + 1
            : index + 1}
        </p>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "30%",
      key: "Name",
      sorter: true,
      showSorterTooltip: false,
      render: (text: any, record: any) => (
        <span>{record?.name}</span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      width: "30%",
      key: "CreatedBy.Date",
      sorter: true,
      showSorterTooltip: false,
      render: (text: any, record: any) => (
        <span>
          {
            Utils.getFormattedDate(record?.date)
          }
        </span>
      ),
    },
    {
      title: "Action",
      // width: "10%",
      render: (_: any, record: any, index: any) => (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {
            !isSubAdmin() &&
            <div style={{ width: 24, textAlign: "center" }}>
              {record.recordStatus === DBRecordStatus.Active &&
                <Tooltip
                  title={new Date(record.date) < new Date(new Date().setHours(0, 0, 0, 0)) ? "Past holidays cannot be edited." : "Edit"}
                  placement="top"
                  color="white"
                  overlayInnerStyle={{ color: "#000" }}
                >
                  <Link
                    className="edit-btn"
                    disabled={new Date(record.date) < new Date(new Date().setHours(0, 0, 0, 0))}
                    onClick={() => {
                      setDialog({ type: "editHoliday", params: { record: record } });
                    }}
                  >
                    <EditTwoTone />
                  </Link>
                </Tooltip>
              }
            </div>
          }
          <div>
            <Tooltip
              title={isSubAdmin() ? "" : new Date(record.date) < new Date(new Date().setHours(0, 0, 0, 0)) ? "You cannot change status of past holidays." : record.recordStatus === DBRecordStatus.Active ? "In-Active" : "Active"}
              placement="top"
              color="white"
              overlayInnerStyle={{ color: "#000" }}
            >
              <Checkbox
                disabled={isSubAdmin() || new Date(record.date) < new Date(new Date().setHours(0, 0, 0, 0))}
                checked={record.recordStatus === DBRecordStatus.Active}
                onChange={(e: any) => {
                  // console.log(new Date(record.date), dayjs().startOf("day"), new Date());
                  setDialog({ type: "isActive", params: { id: record?.id, name: record?.name, recordStatus: record?.recordStatus } });
                }}
              />
            </Tooltip>
          </div>
          {/* <div style={{ width: 24, textAlign: "center" }}>
            <Link
              className="status-btn"
              onClick={async () => {
                setDialog({ type: "deleteHoliday", params: { id: record?.id, name: record?.name } });
              }}
            >
              <DeleteTwoTone twoToneColor="#ff4d4f" />
            </Link>
          </div> */}
        </div>
      ),
    }
  ];

  // if (!isSubAdmin()) {
  //   columns.push(,)
  // }

  const primaryActions: any[] = [];
  if (!isSubAdmin()) {
    primaryActions.push({
      label: "Holiday",
      icon: <PlusOutlined />,
      type: "primary",
      onClick: () => setDialog({ type: "editHoliday", params: {} }),
    });
  }

  const filterCriteria = [
    {
      key: "dateRange",
      label: "Date Range",
      type: "dateRange" as const,
    },
    {
      key: "status",
      label: "Status",
      type: "select" as const,
      options: [
        { value: DBRecordStatus.Active, label: "Active" },
        { value: DBRecordStatus.Deleted, label: "In-Active" },
      ],
      placeholder: "Select Status",
    },
  ];

  const activeFilters = {
    dateRange: selectedDate.fromDate && selectedDate.toDate ? [selectedDate.fromDate, selectedDate.toDate] : undefined,
    status: listParams.status,
  };

  const handleFiltersChange = (newFilters: Record<string, any>) => {
    const dates = newFilters.dateRange || [null, null];
    setSelectedDate({
      fromDate: dates[0],
      toDate: dates[1],
    });
    setListParams({
      ...listParams,
      status: newFilters.status,
      currentPage: 1,
    });
  };

  return (
    <PageLayout>
      <PageHeader title="Holidays" subtitle="Manage public and practice holidays" />
      <SectionCard noPadding>
        <div style={{ padding: "0 16px" }}>
          <TableToolbar
            primaryActions={primaryActions}
            onSearch={(val: string) => setListParams({ ...listParams, search: val, currentPage: 1 })}
            searchPlaceholder="Search holidays..."
            filterCriteria={filterCriteria}
            activeFilters={activeFilters}
            onFiltersChange={handleFiltersChange}
            onRefresh={() => setRefresh(!refresh)}
          />
        </div>
        <Table
          dataSource={updatesList?.items}
          columns={columns}
          size="small"
          scroll={{ x: 800, y: window.innerHeight - 256 }}
          loading={{ spinning: loading, indicator: <Spin indicator={<LoadingOutlined />} /> }}
          className="border-top-table"
          pagination={{
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            current: listParams.currentPage,
            pageSize: listParams.pageSize,
            showSizeChanger: true,
            total: updatesList?.totalItems,
            pageSizeOptions: ["15", "25", "50", "100"],
          }}
          onChange={(paging, filter, sort: any) => {
            if (
              paging?.current !== undefined &&
              paging?.pageSize !== undefined
            ) {
              setLoading(true);
              setListParams({
                ...listParams,
                sortDir: sort.order !== undefined ? sort.order : "ascend",
                sortCol:
                  sort.order !== undefined
                    ? sort.columnKey
                    : "Name",
                currentPage:
                  paging.current !== undefined ? paging.current : 1,
                pageSize:
                  paging.pageSize !== undefined ? paging.pageSize : 15,
              });
            }
          }}
        />
        {dialog.type === "editHoliday" && (
          <HolidaysDetails
            {...dialog.params}
            show={true}
            onDismiss={(confirmed: boolean) => {
              setDialog({ type: "", params: {} });
              if (confirmed) {
                setRefresh((x) => (x = !x));
              }
            }}
          />
        )}
        {(dialog.type === "isActive" || dialog.type === "deleteHoliday") && (
          <ConfirmationModal
            open={true}
            onNo={() => setDialog({ type: "", params: "" })}
            onYes={async () => {
              try {
                const apiData = dialog.type === "isActive" ? await HolidaysService.toggleHolidayStatus(
                  dialog.params?.id,
                  dialog.params?.recordStatus === DBRecordStatus.Deleted
                    ? DBRecordStatus.Active
                    : DBRecordStatus.Deleted
                ) : await HolidaysService.deleteHoliday(dialog.params?.id);
                if (apiData?.status) {
                  openNotification(
                     "success",
                     `Holiday "${dialog?.params?.name}" ${dialog?.params?.recordStatus === DBRecordStatus.Deleted
                       ? "Activated"
                       : "Deactivated"
                     } successfully.`
                  );

                  setRefresh((x) => (x = !x));
                  setDialog({ type: "", params: "" });
                } else {
                  openNotification("error", apiData?.message);
                  console.log("error", apiData?.message);
                  setDialog({ type: "", params: "" });
                }
              } catch (err) {
                openNotification("error", err);
                console.log("error", err);
                setDialog({ type: "", params: "" });
              } finally {
                setDialog({ type: "", params: "" });
              }
            }}
            text={`Are you sure you want to ${dialog?.params?.recordStatus === DBRecordStatus.Deleted
              ? "Activate"
              : "Deactivate"
            } this "${dialog?.params?.name}" holiday?`}
          />
        )}
      </SectionCard>
    </PageLayout>
  );
};

export default Holidays;